import Cookies from 'js-cookie';

import { LATEST_VERSION, VERSION_HEADER } from '~/constants/api';
import { readFromLocalStorage } from '~/utils/local-storage';

import { postDeviceEvent } from '../services/deviceEvent.service';
import {
  type DeviceEvent,
  type DeviceEventRequest,
  type DeviceEventsClient,
} from '../types/deviceEvents.type';

const DEVICE_EVENTS_PATH = '/devices/events';

const getDeviceEventsUrl = (): string =>
  `${CONFIG.quickpackUrl.replace(/\/$/, '')}${DEVICE_EVENTS_PATH}`;

const getDeviceEventsHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {
    Authorization: CONFIG.shippoToken
      ? `ShippoToken ${CONFIG.shippoToken}`
      : `JWT ${Cookies.get('jwt')}`,
    'Content-Type': 'application/json',
    [VERSION_HEADER]: LATEST_VERSION,
  };

  if (ENV_ID !== 'production') {
    headers['X-HTTP-Request-Source'] = `React-${ENV_ID}`;
    const lang = readFromLocalStorage('i18nextLng');
    if (lang) headers['Accept-Language'] = lang;
  }

  return headers;
};

const buildDeviceEventRequest = (deviceEvent: DeviceEvent): DeviceEventRequest =>
  ({
    payload: {
      event_name: deviceEvent.event,
      ...deviceEvent.properties,
    },
  }) as DeviceEventRequest;

export const createDeviceEventsClient = (): DeviceEventsClient => ({
  emit: async (deviceEvent: DeviceEvent): Promise<void> => {
    await postDeviceEvent(buildDeviceEventRequest(deviceEvent));
  },

  emitBeacon: (deviceEvent: DeviceEvent): void => {
    void fetch(getDeviceEventsUrl(), {
      body: JSON.stringify(buildDeviceEventRequest(deviceEvent)),
      headers: getDeviceEventsHeaders(),
      keepalive: true,
      method: 'POST',
    }).catch(() => undefined);
  },
});
